import React, { Component } from 'react'
import { connect } from 'react-redux'
import ProductList from './ProductList'
import LinearProgess from 'material-ui/Progress/LinearProgress'
import {
  fetchProducts,
  clearSuccessMessage,
  resetInMemoryProduct
} from './products-reducer'

class ProductListContainer extends Component {
  componentDidMount () {
    const { fetchProducts, products } = this.props

    if (products.length === 0) {
      fetchProducts()
    }
  }

  render () {
    const {
      products,
      requestOngoing,
      clearSuccessMessage,
      resetInMemoryProduct,
      history
    } = this.props
    let viewToRender

    const handleNewProduct = () => {
      resetInMemoryProduct()
      clearSuccessMessage()
      history.push('/products/form')
    }

    if (requestOngoing) {
      viewToRender = <LinearProgess />
    } else {
      viewToRender = (
        <ProductList products={products} handleNewProduct={handleNewProduct} />
      )
    }

    return (
      <div>
        <h4>Products</h4>
        {viewToRender}
      </div>
    )
  }
}

const mapStateToProps = ({ products: { products, requestOngoing } }) => ({
  products,
  requestOngoing
})

const mapDispatchToProps = {
  fetchProducts,
  clearSuccessMessage,
  resetInMemoryProduct
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ProductListContainer
)



// WEBPACK FOOTER //
// ./src/products/ProductListContainer.js